"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var lock_data_model_1 = require("../model/lock-data.model");
var core_1 = require("@angular/core");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var logger_1 = require("../helper/logger");
require("rxjs/add/observable/from");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/do");
require("rxjs/add/operator/catch");
var http_1 = require("@angular/common/http");
require("rxjs/add/operator/first");
var LockingHttpService = /** @class */ (function () {
    function LockingHttpService(http, applicationPropertiesService, authenticationService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.authenticationService = authenticationService;
        this.URL_LOCK_ADD = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/locks/", "/", "/", ""], ["", "/locks/", "/", "/", ""])), "serviceUrl", "userId", "categoryId", "entityId");
        this.URL_LOCK_REMOVE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/locks/", "/", "/", ""], ["", "/locks/", "/", "/", ""])), "serviceUrl", "userId", "categoryId", "entityId");
        this.URL_LOCK_LOAD_ONE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/locks/", "/", ""], ["", "/locks/", "/", ""])), "serviceUrl", "categoryId", "entityId");
        this.URL_LOCK_LOAD_ALL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "/locks"], ["", "/locks"])), "serviceUrl");
        this.URL_LOCK_CAN_EDIT = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "/generallocks/edit/", "/", "/", ""], ["", "/generallocks/edit/", "/", "/", ""])), "serviceUrl", "categoryId", "entityId", "userId");
        this.URL_LOCK_CAN_DELETE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", "/generallocks/delete/", "/", "/", ""], ["", "/generallocks/delete/", "/", "/", ""])), "serviceUrl", "categoryId", "entityId", "userId");
        this.URL_PERMANENT_LOCK_LOAD_ONE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", "/permanentlocks/", "/", ""], ["", "/permanentlocks/", "/", ""])), 'serviceUrl', 'categoryId', 'entityId');
        this.lockingServiceUrlKey = "lock-service-url";
        this.lockingServiceUrlKey$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.lockingServiceUrlKey));
        this.authenticatedUserData$ = this.authenticationService.getUserData();
    }
    LockingHttpService.prototype.addLock = function (categoryId, entityId, entityName) {
        var _this = this;
        var url$ = Observable_1.Observable.combineLatest(this.authenticatedUserData$, this.lockingServiceUrlKey$)
            .first()
            .map(function (data) {
            var userData = data[0];
            var serviceUrl = data[1];
            return _this.URL_LOCK_ADD.replaceTemplate({
                "serviceUrl": serviceUrl,
                "categoryId": categoryId,
                "entityId": entityId.toString(),
                "userId": userData.userId.toString()
            });
        });
        return url$.mergeMap(function (url) {
            var httpParams = new http_1.HttpParams().set("entityName", entityName ? entityName : categoryId + entityId);
            return _this.http.post(url, null, { params: httpParams });
        });
    };
    LockingHttpService.prototype.removeLock = function (categoryId, entityId) {
        var _this = this;
        var url$ = Observable_1.Observable.combineLatest(this.authenticatedUserData$, this.lockingServiceUrlKey$)
            .first()
            .map(function (data) {
            var userData = data[0];
            var serviceUrl = data[1];
            return _this.URL_LOCK_REMOVE.replaceTemplate({
                "serviceUrl": serviceUrl,
                "categoryId": categoryId,
                "entityId": entityId.toString(),
                "userId": userData.userId.toString()
            });
        });
        return url$.mergeMap(function (url) {
            return _this.http.delete(url);
        });
    };
    LockingHttpService.prototype.removeLockByEntityId = function (categoryId, entityId) {
        var _this = this;
        var url$ = Observable_1.Observable.combineLatest(this.authenticatedUserData$, this.lockingServiceUrlKey$)
            .first()
            .map(function (data) {
            var userData = data[0];
            var serviceUrl = data[1];
            return _this.URL_LOCK_REMOVE.replaceTemplate({
                "serviceUrl": serviceUrl,
                "categoryId": categoryId,
                "entityId": entityId.toString(),
                "userId": userData.userId.toString()
            });
        });
        return url$.mergeMap(function (url) {
            return _this.http.delete(url);
        });
    };
    LockingHttpService.prototype.getLock = function (categoryId, entityId) {
        var _this = this;
        var url$ = this.lockingServiceUrlKey$
            .first()
            .map(function (lockingServiceUrl) {
            return _this.URL_LOCK_LOAD_ONE.replaceTemplate({
                "serviceUrl": lockingServiceUrl,
                "categoryId": categoryId,
                "entityId": entityId.toString()
            });
        });
        return url$.mergeMap(function (url) {
            logger_1.Logger.log("LockingService:loadlock:" + url);
            return _this.http.get(url);
        }).map(function (lockJson) { return deserializeLockData(categoryId, entityId, lockJson); });
    };
    LockingHttpService.prototype.getAllLocks = function (page, size) {
        var _this = this;
        var url$ = this.lockingServiceUrlKey$
            .first()
            .map(function (lockingServiceUrl) {
            return _this.URL_LOCK_LOAD_ALL.replaceTemplate({
                "serviceUrl": lockingServiceUrl
            });
        });
        return url$.mergeMap(function (url) {
            var httpParams = new http_1.HttpParams().set("page", page.toString()).set("size", size.toString());
            return _this.http.get(url, { params: httpParams });
        }).map(function (allLockDataJson) { return deserializeAllLockData(allLockDataJson); });
    };
    LockingHttpService.prototype.canEdit = function (categoryId, entityId) {
        var _this = this;
        var url$ = Observable_1.Observable.combineLatest(this.authenticatedUserData$, this.lockingServiceUrlKey$)
            .first()
            .map(function (data) {
            var userData = data[0];
            var serviceUrl = data[1];
            return _this.URL_LOCK_CAN_EDIT.replaceTemplate({
                "serviceUrl": serviceUrl,
                "categoryId": categoryId,
                "entityId": entityId.toString(),
                "userId": userData.userId.toString(),
            });
        });
        return url$.mergeMap(function (url) {
            return _this.http.get(url);
        }).map(function (data) { return (data.toString() === 'true'); });
    };
    LockingHttpService.prototype.canDelete = function (categoryId, entityId) {
        var _this = this;
        var url$ = Observable_1.Observable.combineLatest(this.authenticatedUserData$, this.lockingServiceUrlKey$)
            .first()
            .map(function (data) {
            var userData = data[0];
            var serviceUrl = data[1];
            return _this.URL_LOCK_CAN_DELETE.replaceTemplate({
                "serviceUrl": serviceUrl,
                "categoryId": categoryId,
                "entityId": entityId.toString(),
                "userId": userData.userId.toString(),
            });
        });
        return url$.mergeMap(function (url) {
            return _this.http.get(url);
        }).map(function (data) { return (data.toString() === 'true'); });
    };
    LockingHttpService.prototype.getPermanentLock = function (categoryId, entityId) {
        var _this = this;
        return this.lockingServiceUrlKey$
            .pipe(operators_1.first(), operators_1.map(function (lockingServiceUrl) {
            return _this.URL_PERMANENT_LOCK_LOAD_ONE
                .replaceTemplate({
                'serviceUrl': lockingServiceUrl,
                'categoryId': categoryId,
                'entityId': entityId.toString()
            });
        }), operators_1.switchMap(function (url) { return _this.http.get(url); }), operators_1.map(function (lockJson) { return deserializeLockData(categoryId, entityId, lockJson); }));
    };
    LockingHttpService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.AuthenticationService])
    ], LockingHttpService);
    return LockingHttpService;
}());
exports.LockingHttpService = LockingHttpService;
function deserializeLockData(categoryId, entityId, jsonItem) {
    if (jsonItem == null || jsonItem && !jsonItem.userId) {
        return new lock_data_model_1.LockData(null, null, null, null, null, null, null);
    }
    var lockData = new lock_data_model_1.LockData(jsonItem.categoryId, jsonItem.entityId, jsonItem.entityName, jsonItem.userId, jsonItem.userFullName, jsonItem.timestamp, jsonItem.sessionKey);
    logger_1.Logger.log("LockingService:" + categoryId + ":" + entityId + " is " + (lockData.getIsLocked() ? 'locked' : 'not locked'));
    return lockData;
}
exports.deserializeLockData = deserializeLockData;
function deserializeAllLockData(allLockJson) {
    var allLockData = [];
    var allLockDataSerialized = allLockJson.json ? allLockJson.json() : allLockJson; //done for loading json from file as well
    allLockDataSerialized.forEach(function (item) {
        allLockData.push(deserializeLockData(item.categoryId, item.entityId, item));
    });
    return allLockData;
}
exports.deserializeAllLockData = deserializeAllLockData;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=lock-http.service.js.map